"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _usePrevious = require("b2b-components/hooks/usePrevious");
var _useScript = require("b2b-components/hooks/useScript");
var _getDisplayName = require("b2b-components/utils/getDisplayName");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _sumItemsFromProps = require("../../../utils/sumItemsFromProps");
var _ = require("../../");
var _excluded = ["maxThumbnailCount"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var withContainer = function withContainer(Component) {
  var WithContainer = function WithContainer(props) {
    var maxThumbnailCount = props.maxThumbnailCount,
      originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
    var currentItemType = originalProps.currentItemType,
      image360 = originalProps.image360,
      images = originalProps.images,
      isMobile = originalProps.isMobile,
      isPreview = originalProps.isPreview,
      onItemChange = originalProps.onItemChange,
      totalItemCount = originalProps.totalItemCount,
      text = originalProps.text,
      videos = originalProps.videos;
    var prevItemType = (0, _usePrevious.usePrevious)(currentItemType);
    var moreItemCount = (0, _react.useMemo)(function () {
      var itemCount = (0, _sumItemsFromProps.sumItemsFromProps)({
        image360: image360,
        images: images,
        videos: videos
      });
      if (itemCount === totalItemCount || maxThumbnailCount >= totalItemCount || !isPreview) {
        return 0;
      }
      return totalItemCount - maxThumbnailCount;
    }, [image360, images, isPreview, maxThumbnailCount, totalItemCount, videos]);
    var handleThumbnailClick = function handleThumbnailClick(itemIndex) {
      return function (e) {
        e.preventDefault();
        onItemChange === null || onItemChange === void 0 ? void 0 : onItemChange(itemIndex);
      };
    };
    (0, _useScript.useScript)('/magiczoom.js');
    (0, _useScript.useScript)('/magic360.js');
    (0, _react.useEffect)(function () {
      if (!isPreview) {
        window.mzOptions = {
          onZoomIn: function onZoomIn() {
            window.mzIsZoomed = true;
          },
          onZoomOut: function onZoomOut() {
            window.mzIsZoomed = false;
          }
        };
        window.Magic360Lang = {
          'hint-text': text.spinHint,
          'mobile-hint-text': text.spinHintMobile
        };
        if (prevItemType !== currentItemType && currentItemType === _.GALLERY_ITEM_TYPE.image360) {
          var _window$Magic, _window$Magic$start;
          (_window$Magic = window.Magic360) === null || _window$Magic === void 0 ? void 0 : (_window$Magic$start = _window$Magic.start) === null || _window$Magic$start === void 0 ? void 0 : _window$Magic$start.call(_window$Magic);
        }
      }
    }, [
    // it seems that a few deps below are not neccessary, but they are
    // otherwise there is a bug with mobileMenu
    currentItemType, image360, isMobile, isPreview, prevItemType, text]);
    var injectedProps = {
      moreItemCount: moreItemCount,
      onThumbnailClick: handleThumbnailClick
    };
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, originalProps, injectedProps));
  };
  WithContainer.displayName = "withContainer(".concat((0, _getDisplayName.getDisplayName)(Component), ")");
  (0, _hoistNonReactStatics["default"])(WithContainer, Component);
  return WithContainer;
};
exports.withContainer = withContainer;